// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"HomePage_visuallyHidden__4hQCs"};